@if (data.variant === 'onboardingConfirm') {
  <h2 mat-dialog-title class="!m-0 text-lg font-bold text-slate-900">
    Kostenloser Plan
  </h2>
  <mat-dialog-content class="!pt-3 text-sm leading-relaxed text-slate-600">
    <p class="m-0">
      Im kostenlosen Plan ist einmalig <strong>ein Inserat pro Organisation für sechs Monate</strong> enthalten. Entwürfe sind kostenlos. Weitere Ausschreibungen sind mit einer Einzellizenz oder einem Abo möglich.
    </p>
    <p class="m-0 mt-3 text-slate-500">
      Möchtest du mit dem kostenlosen Plan fortfahren?
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="!justify-between gap-2">
    <button mat-button type="button" (click)="cancelOnboarding()">
      Zurück
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="confirmFreeOnboarding()">
      Ja, kostenlos starten
    </button>
  </mat-dialog-actions>
} @else {
  <h2 mat-dialog-title class="!flex items-center gap-3 !pb-2">
    <span
      class="flex h-10 w-10 items-center justify-center rounded-full bg-bn-blue-light shrink-0">
      <mat-icon class="text-light-primary">bolt</mat-icon>
    </span>
    <span class="text-2xl font-bold text-light-on-surface leading-tight">
      Limit für kostenlose Inserate
    </span>
  </h2>

  <mat-dialog-content class="!pt-0">
    @if (isInvitedMemberOnly) {
      <p class="m-0 text-base text-bn-grey-font">
        Du bist als Admin einer Organisation hinterlegt. Abonnemente und
        Freischaltungen werden von der Eigentümerin bzw. dem Eigentümer der
        Organisation verwaltet — wende dich an sie, um zusätzliche Inserate
        freizuschalten.
      </p>
    } @else {
      <p class="m-0 mb-5 text-base text-bn-grey-font">
        @if (canPurchaseSinglePosting) {
          Im kostenlosen Plan ist ein Inserat enthalten. Wähle, wie du
          fortfahren möchtest.
        } @else {
          Im kostenlosen Plan ist ein Inserat enthalten. Für weitere Inserate
          und alle Funktionen kannst du auf ein bezahltes Abo upgraden.
        }
      </p>

      <div class="flex flex-col gap-3">
        @if (canPurchaseSinglePosting) {
          <!-- Einzelinserat -->
          <div
            class="rounded-xl border border-bn-blue-medium bg-bn-chat-light-blue p-5">
            <p class="m-0 mb-1 text-sm font-medium text-bn-dark-grey">
              Einzelinserat
            </p>
            <div class="flex items-baseline gap-1 mb-4">
              <span class="text-2xl font-bold text-light-primary">
                {{ singlePostingPriceLabel }}
              </span>
              <span class="text-sm text-bn-grey-font">einmalig</span>
            </div>
            <ul
              class="m-0 list-none p-0 border-t border-bn-blue-medium pt-3 space-y-2 mb-4">
              <li class="flex items-center gap-2.5">
                <mat-icon
                  class="text-emerald-600 !h-4 !w-4 !min-h-4 !min-w-4 !text-base !leading-4 shrink-0"
                  >check_circle</mat-icon
                >
                <span class="text-sm text-light-on-surface-variant leading-5">
                  Nur dieses eine Inserat freischalten
                </span>
              </li>
            </ul>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="!w-full"
              (click)="purchaseSinglePosting()">
              Freischalten
            </button>
          </div>
        }

        <!-- Abo-Upgrade -->
        <div
          class="rounded-xl border-2 border-light-primary bg-bn-chat-light-blue p-5">
          <div class="flex items-center justify-between gap-3 mb-1">
            <p class="m-0 text-sm font-medium text-bn-dark-grey">Abo-Upgrade</p>
            <span
              class="badge bg-light-primary font-semibold text-white">
              <mat-icon
                class="!h-3.5 !w-3.5 !min-h-3.5 !min-w-3.5 !text-sm !leading-[0.875rem] shrink-0"
                >star</mat-icon
              >
              Empfohlen
            </span>
          </div>
          <ul class="m-0 list-none p-0 pt-3 space-y-2 mb-4">
            <li class="flex items-center gap-2.5">
              <mat-icon
                class="text-emerald-600 !h-4 !w-4 !min-h-4 !min-w-4 !text-base !leading-4 shrink-0"
                >check_circle</mat-icon
              >
              <span class="text-sm text-light-on-surface-variant leading-5">
                Unbegrenzte Inserate
              </span>
            </li>
            <li class="flex items-center gap-2.5">
              <mat-icon
                class="text-emerald-600 !h-4 !w-4 !min-h-4 !min-w-4 !text-base !leading-4 shrink-0"
                >check_circle</mat-icon
              >
              <span class="text-sm text-light-on-surface-variant leading-5">
                Alle Funktionen freischalten
              </span>
            </li>
          </ul>
          <button
            mat-flat-button
            color="primary"
            type="button"
            class="!w-full"
            (click)="openUpgrade()">
            Jetzt upgraden
          </button>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="closeLimit()">Schliessen</button>
  </mat-dialog-actions>
}
